import { ISpecialist, SupportedCurrencies } from '../../redux/specialists/types';
import { environment } from '../../enviroments';
import { HttpHandler } from '../../api/HttpHandler';
import { StripeSupportedCurrency } from './type';

export const makeid = (length: number): string => {
  //Result variable of Id
  let result = '';
  //A list of all symbols
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  //For which create an id
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  //Return the result
  return result;
};

export const calculateSessionPrice = (psychologist: ISpecialist, personalPrice: number) => {
  return personalPrice && personalPrice > 0
    ? personalPrice
    : psychologist?.session_price ?? psychologist?.session_price_uah;
};

export const getStripeInfo = async (stripeMetadataObj: any): Promise<any> => {
  const requestURL = `${environment.PAYMENTS_URL}/paymentIntent`;

  const response = await HttpHandler({
    method: 'POST',
    url: requestURL,
    data: stripeMetadataObj,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};

export const cutTo2Decimals = (value: number) => Math.trunc(value * 100) / 100;

export const delay = async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const correctPriceType = (value: SupportedCurrencies) =>
  StripeSupportedCurrency.includes(value) ? value : SupportedCurrencies.EUR;
